import React from 'react';
import Card from './Card';
import { QuoteIcon } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
}
export default function Testimonial({
  quote,
  author
}: TestimonialProps) {
  return <Card className="h-full" data-id="element-119">
      <div className="flex flex-col h-full" data-id="element-120">
        <QuoteIcon className="h-8 w-8 text-sky-blue mb-4" data-id="element-121" />
        <p className="text-dark text-lg mb-4 flex-grow italic" data-id="element-122">{quote}</p>
        <p className="text-navy font-semibold" data-id="element-123">— {author}</p>
      </div>
    </Card>;
}